













































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import SendEmailDialog from '@/components/SendEmailDialog.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import FieldDefs from './FieldDefs';
import {commitAddNotification} from '@/store/main/mutations';

@Component({
  components: {
    SendEmailDialog,
    ConfirmDialog
  }
})
export default class SalesDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public billitMode = true;

  public isProformaCustomer() {
    const ref: any = this.$refs.customer;
    if (ref) {
      const option = ref.findOptionRec();
      if (option) {
        // console.log('isProformaCustomer', option);
        return option.is_proforma_customer;
      }
    }
    return false;
  }
  public showSendAccounting() {
    if (this.billitMode) {
      return false;
    }
    if (!this.roleCheckAPI('sale', 'sendaccounting')) {
      return false;
    }
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      //  console.log('showSendAccounting', layout.rec.is_closed, layout.rec.is_locked);
       return !layout.rec.is_closed && !layout.rec.is_locked;
    } else {
      return false;
    }
  }

  public showSendBillet() {
    if (!this.roleCheckAPI('sale', 'sendaccounting')) {
      return false;
    }
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      //  console.log('showSendBillet', layout.rec.sent_billit);
       return !layout.rec.sent_billit && !layout.rec.is_closed && !layout.rec.is_locked;
    } else {
      return false;
    }
  }

  public showSendMail() {
    if (this.billitMode) {
      return this.isProformaCustomer();
    }
    if (!this.roleCheckAPI('sale', 'getmailtemplate')) {
      return false;
    }
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      //  console.log('showSendMail', layout.rec.is_closed, layout.rec.is_locked);
       return !layout.rec.is_locked;
    } else {
      return true;
    }
  }

  public emailWasSent(id, response) {
    const ref: any = this.$refs.layout;
    if (response && response.status) {
      this.$set(ref.rec, 'is_locked', true);
    } else {
      console.log(response);
      commitAddNotification(this.$store, { content: 'Probleem met email versturen', color: 'error' });
    }
  }
  public async sendAccounting(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/sendaccounting');
    this.$set(rec, 'is_locked', true);
  }

  public async sendBillit(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/sendbillit');
    this.$set(rec, 'is_locked', true);
  }

  public async resetAccounting(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/resetaccounting');
    this.$set(rec, 'sent_accounting', null);
  }

  public showResetBillitExport(rec) {
    return this.roleCheckAPI('sale', 'resetbillitexport') && !!rec.sent_billit;
  }

  public async resetBillitExport(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/resetbillitexport');
    const ref: any = this.$refs.layout;
    await ref.getRecord();
  }

  public async recalculate(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/recalculate');
    console.log(response);
    const ref: any = this.$refs.layout;
    ref.onUndoEdit();
  }




}
